export default "/icons/Adobe_illustrator_icon.svg";